// History and undo (milestone 12).
import { requestRaw } from './api'

export interface ChangeSet {
  id: number
  actor_name: string
  actor_kind: 'user' | 'agent' | 'system'
  on_behalf_of: string | null
  summary: string
  undo_of: number | null
  undone_by: number | null
  created_at: string
  actions: string[]
  undoable: boolean
  items?: { kind: string; slug: string; before: unknown; after: unknown }[]
}

const json = async <T,>(method: string, path: string, body?: unknown) => (await requestRaw(method, path, body)).json() as Promise<T>

export const changesApi = {
  list: (kind = '', slug = '') => json<ChangeSet[]>('GET', `/changes?${new URLSearchParams({ kind, slug })}`),
  get: (id: number) => json<{ set: ChangeSet; role: 'editor' | 'admin' }>('GET', `/changes/${id}`),
  undo: (id: number) => json<{ undone: number; change: number }>('POST', `/changes/${id}/undo`, {}),
}
